<template>
  <el-dialog
    class="mode"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="true"
    :title="title"
    top="5vh"
    width="580px"
    :visible.sync="show"
    append-to-body
  >
    <vab-form ref="form" :model="form" :rules="rules">
      <vab-row
        v-for="(row, index) in form.scheduleAdjDetailModelList"
        :key="index"
        class="row_box new_workInfo"
      >
        <vab-col :span="24" class="word_box nopadding notop border_none">
          <vab-row class="flex_center_align">
            <vab-col :span="3" class="flex_center_align">
              <span class="tz_title">日程</span>
            </vab-col>
            <vab-col :span="20" class="date_picker">
              <div class="flex_start tz_right flex_center_align">
                <vab-date-picker
                  type="date"
                  :label-show="false"
                  value-format="yyyy/MM/dd"
                  format="yyyy/MM/dd"
                  :validate="vaildateTimeStart(row, index)"
                  label-error="日程"
                  :prop="`scheduleAdjDetailModelList.${index}.startDateTime`"
                  :end-date-prop="`scheduleAdjDetailModelList.${index}.endDateTime`"
                  :disabled="row.timeDisabled"
                  @change="
                    (value) =>
                      changeWattingDate(row, index, value, 'startDateTime')
                  "
                />
                <div class="line">～</div>
                <vab-date-picker
                  type="date"
                  :label-show="false"
                  value-format="yyyy/MM/dd"
                  format="yyyy/MM/dd"
                  :validate="vaildateTimeEnd(row, index)"
                  label-error="日程"
                  :prop="`scheduleAdjDetailModelList.${index}.endDateTime`"
                  :start-date-prop="`scheduleAdjDetailModelList.${index}.startDateTime`"
                  :disabled="row.timeDisabled"
                  @change="
                    (value) =>
                      changeWattingDate(row, index, value, 'endDateTime')
                  "
                />
              </div>
            </vab-col>
          </vab-row>
          <vab-row>
            <vab-col :span="3" class="flex_center_align">
              <span class="tz_title">時間</span>
            </vab-col>
            <vab-col :span="20" class="time_picker">
              <div class="flex_start flex_center_align">
                <vab-time-picker
                  :prop="`scheduleAdjDetailModelList.${index}.startTime`"
                  format="HH:mm"
                  value-format="HH:mm"
                  :value-format-sss="true"
                  :disabled="row.disabled"
                  :end-date-prop="`scheduleAdjDetailModelList.${index}.endTime`"
                ></vab-time-picker>
                <div class="line">～</div>
                <vab-time-picker
                  :prop="`scheduleAdjDetailModelList.${index}.endTime`"
                  format="HH:mm"
                  value-format="HH:mm"
                  :value-format-sss="true"
                  :disabled="row.disabled"
                  :start-date-prop="`scheduleAdjDetailModelList.${index}.startTime`"
                ></vab-time-picker>
                <div class="end_box">
                  <vab-checkbox
                    label="終日"
                    :prop="`scheduleAdjDetailModelList.${index}.dayFlag`"
                    :code-enum="$divisions.validFlgEnum"
                    :disabled="row.checkDisabled"
                    @change="(value) => changeDayFlag(value, row)"
                  ></vab-checkbox>
                </div>
              </div>
            </vab-col>
          </vab-row>
        </vab-col>
      </vab-row>
    </vab-form>
    <div slot="footer" class="dialog-footer flex_end">
      <div class="flex_start flex_center_align">
        <!-- <div class="quxiao" @click="handleCancel">キャンセル</div> -->
        <el-button class="cancel" @click="handleCancel">キャンセル</el-button>
        <el-button class="changebtn w104" @click="handleConfirm">
          選択
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  import mixinSchedule from '@/utils/mixinSchedule'
  export default {
    name: 'Day',
    mixins: [mixinSchedule],
    inject: {
      formData: { default: () => ({}) },
      pageInfo: { default: () => ({}) },
      setTimeList: { default: () => ({}) },
    },
    data() {
      return {
        show: false,
        title: '',
        rules: {},
        form: {
          scheduleAdjDetailModelList: [],
        },
        rowIndex: -1,
      }
    },
    computed: {
      parentForm() {
        return this.formData()
      },
      info() {
        return this.pageInfo()
      },
      timeList() {
        let list = []
        this.parentForm.scheduleAdjDetailModelList.forEach((item, pindex) => {
          if (this.rowIndex == -1) {
            if (!item.startDateTime || !item.endDateTime) {
              this.rowIndex = pindex
              list.push(item)
            }
          }
        })
        return list
      },
    },
    methods: {
      // 取消按钮
      handleCancel() {
        this.rowIndex = -1
        this.form.scheduleAdjDetailModelList = []
        this.show = false
      },
      // 終日
      changeDayFlag(val, row) {
        if (val === this.$divisions.validFlgEnum.enum_1.value) {
          row.disabled = true
          row.startTime = null
          row.endTime = null
        } else {
          row.disabled = false
        }
        this.$forceUpdate()
      },
      // 候補時間を選択する
      async changeWattingDate(row, index, value, key) {
        //「SC1」事前調査の場合、不可日を選択提醒
        if (
          (this.isEqualCodeEnum(
            this.getFieldValue('demandType', this.info),
            this.$divisions.demandTypeEnum.enum_1
          ) ||
            this.isEqualCodeEnum(
              this.getFieldValue('demandType', this.info),
              this.$divisions.demandTypeEnum.enum_6
            )) &&
          this.isEqualCodeEnum(
            this.getFieldValue('requestIdModel.requestClass', this.info),
            this.$divisions.requestClassEnum.enum_1
          )
        ) {
          // let noDayList = this.vm.noDayList
          // if (
          //   noDayList.some((time) =>
          //     this.$dayjs(time.date).isSame(value, 'day')
          //   )
          // ) {
          //   this.msgInfo(
          //     this.$t(`validateMessage.${this.$messageCode.W00000286.name}`)
          //   )
          // }
          // if (this.checkCalendar(value, this.vm.calendarList)) {
          //   this.msgInfo(
          //     this.$t(`validateMessage.${this.$messageCode.W00000217.name}`)
          //   )
          // }
          this.checkDayReportRequest(row)
        }

        // 「SC3」事前調査の場合、不可日を選択不可
        if (
          this.isEqualCodeEnum(
            this.getFieldValue('demandType', this.info),
            this.$divisions.demandTypeEnum.enum_3
          ) &&
          this.isEqualCodeEnum(
            this.getFieldValue('requestIdModel.requestClass', this.info),
            this.$divisions.requestClassEnum.enum_1
          )
        ) {
          // let noDayList = this.vm.noDayList
          // let check = this.checkNoDay(row, value, key, noDayList)
          // if (check) {
          //   this.msgError(
          //     this.format(
          //       this.$t(`validateMessage.${this.$messageCode.W00000428.name}`)
          //     )
          //   )
          //   return
          // }
          let error = await this.checkDayReportError(row, key, 'error')
          if (error) {
            return
          }
        }
        // 「SC3」工事・作業、不可日を選択提醒
        if (
          this.isEqualCodeEnum(
            this.getFieldValue('demandType', this.info),
            this.$divisions.demandTypeEnum.enum_3
          ) &&
          this.isEqualCodeEnum(
            this.getFieldValue('requestIdModel.requestClass', this.info),
            this.$divisions.requestClassEnum.enum_2
          )
        ) {
          // let noDayList = this.vm.noDayList
          // let check = noDayList.some((time) =>
          //   this.$dayjs(time.date).isSame(value, 'day')
          // )
          // if (check) {
          //   this.msgInfo(
          //     this.$t(`validateMessage.${this.$messageCode.W00000213.name}`)
          //   )
          // }
          this.checkDayReportError(row)
        }
        if (this.$baseLodash.isEmpty(row.startDateTime)) {
          row.startDateTime = value
        }
        if (this.$baseLodash.isEmpty(row.endDateTime)) {
          row.endDateTime = value
        }
        if (
          !this.$baseLodash.isEmpty(row.startDateTime) &&
          !this.$baseLodash.isEmpty(row.endDateTime)
        ) {
          let isSame = this.$dayjs(row.startDateTime).isSame(
            row.endDateTime,
            'day'
          )
          if (!isSame) {
            row.disabled = true
            row.startTime = null
            row.endTime = null
            row.checkDisabled = true
            // 終日値は空です
            if (this.checkEnumFlag(row.dayFlag)) {
              row.dayFlag = this.$divisions.validFlgEnum.enum_0.value
            }
          } else {
            row.disabled = false
            row.checkDisabled = false
            row.dayFlag = this.$divisions.validFlgEnum.enum_0.value
          }
        }
      },
      setWattingList(list) {
        this.setTimeList(this.$baseLodash.cloneDeep(list[0]), this.rowIndex)
        if (list.length > 0) {
          let hbList = []
          let colorList = ['#FA7830', '#42B86A', '#B077EA']
          let bgColor = [
            'rgba(250, 120, 48, 0.06)',
            'rgba(66, 184, 106, 0.06)',
            'rgba(176, 119, 234, 0.06)',
          ]
          list.filter((row) => {
            let data = {
              id: row.id ?? this.rowIndex + 1,
              title: '候補日程' + (this.rowIndex + 1),
              icon: 'check_circle_line',
              time: `${row.startDateTime}〜${row.endDateTime}`,
              color: colorList[this.rowIndex % 3],
              bg: bgColor[this.rowIndex % 3],
              hbbg: bgColor[this.rowIndex % 3],
              type: 'watting',
              start: this.$dayjs(row.startDateTime).format(
                this.$const.dateFormatYYYYMMDD
              ),
              end: this.$dayjs(row.endDateTime).format(
                this.$const.dateFormatYYYYMMDD
              ),
            }
            hbList.push(data)
            if (this.$dayjs(row.startDateTime).isValid()) {
              row.startTime = this.$dayjs(row.startDateTime).format('HH:mm')
            }
            if (this.$dayjs(row.endDateTime).isValid()) {
              row.endTime = this.$dayjs(row.endDateTime).format('HH:mm')
            }
          })
          let cloneVmList = this.$baseLodash.cloneDeep(this.vm.list)
          cloneVmList.forEach((obj, idx) => {
            hbList.forEach((o) => {
              if (Object.is(obj.title, o.title)) {
                cloneVmList.splice(idx, 1, o)
              }
            })
          }) // let changeList = [...this.vm.list, ...hbList]
          this.vm.clearFillForm(cloneVmList)
          this.show = false
          this.form.scheduleAdjDetailModelList = []
          this.rowIndex = -1
        }
      },
      // 确定按钮
      handleConfirm() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            this.setWattingList(this.form.scheduleAdjDetailModelList)
          } else {
            return false
          }
        })
      },
      // 初始化数据
      initData(data) {
        if (!this.checkEnumFlag(this.parentForm.dealingFlg)) return
        if (this.timeList.length == 0) {
          if (this.parentForm.scheduleAdjDetailModelList.length == 0) {
            return
          }
          this.msgError(
            this.format(
              this.$t(`validateMessage.${this.$messageCode.E00000121.name}`),
              this.parentForm.scheduleAdjDetailModelList.length
            )
          )
          return
        }
        this.title = '候補日程' + Number(this.rowIndex + 1)
        if (data?.vm) {
          this.vm = data.vm
        }
        this.form.scheduleAdjDetailModelList = []
        this.rowIndex = -1
        this.$baseLodash.cloneDeep(this.timeList[0])
        this.form.scheduleAdjDetailModelList.push(
          this.$baseLodash.cloneDeep({
            ...this.timeList[0],
            disabled: true,
            checkDisabled: false,
          })
        )
        this.show = true
      },
    },
  }
</script>

<style lang="scss" scoped>
  .quxiao {
    font-weight: 500;
    font-size: 14px;
    color: #848484;
    padding: 0 30px;
    cursor: pointer;
  }
  .m20 {
    margin: 0 20px;
  }
  .w104 {
    width: 104px;
    height: 32px;
  }
  .mode {
    display: flex;
    align-items: center;
  }
  .sec80 {
    width: 80px;
  }
  .line {
    padding: 0 8px;
    font-size: 13px;
    color: #000000;
    display: inline-block;
  }
  .mode ::v-deep {
    .el-dialog__title {
      color: #003350;
      text-align: left;
    }
    .el-dialog__footer {
      border-top: none;
    }
    .el-dialog__body {
      padding-top: 20px;
    }
  }
</style>
